import { getAdvData } from '@/components/adv-components/adv-common-api';
import { AdvIdEnum } from '@/enums/advIdEnum';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { openThirdPage } from '@/api/native/utils';
import { getRightAliPayUrl } from '@/api/rights';
import { RightPackageSourceEnum, RightPackageTypeEnum } from '@/api/rights/types';
import { MembersRightsPrefix } from '@/constant';
import URLUtils from '@/shared/utils/URLUtils';
import store from '@/store';
import platform from '@/shared/utils/platform';
import { MemberRouterNameEnum } from '@/shared/right-utils/routerName';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import {
  Button, Radio, Popup, DialogView, Badge,
} from '@hb/coffee';
import { ForceReadService } from '@/widgets/right-contract';
import style from './index.module.scss';


export type ApplyProcessingPop = {
  jiweiChannelBPayMoney: string;
  btnImg?: string;
  bgImg?: string;
  jiweiChannelBDetailPage: string;
  jiweiChannelBSaveMoney: string;
  impId: string;
}

@Component
export default class ApplyProcessPop extends Vue {
  /** 产品id */
  @Prop(String) readonly commodityId!: string;

  /** 定价标签 */
  @Prop(String) readonly pricingType?: string;

  /** 广告配置数据 */
  private configData: ApplyProcessingPop | undefined;

  /** 广告位埋点数据 */
  private trackerData: Dictionary | undefined;

  private show = false;

  private contractChecked = false;

  private showContractDialog = false;

  // 合同场景
  private contractScene = '';

  private zxCardAppContractInstance = ForceReadService({
    packageType: RightPackageTypeEnum.CHANNEL_B,
    forceReadFromScene: RightPackageSourceEnum.LOAN_RESULT_POP,
  });

  private rightsModelType = 1;

  private get tqParams() {
    return {
      productId: this.commodityId || '',
      taskId: (this.trackerData && this.trackerData.task_id) || '',
      childrenTaskId: (this.trackerData && this.trackerData.child_task_id) || '',
      taskName: (this.trackerData && this.trackerData.task_name) || '',
      childrenTaskName: (this.trackerData && this.trackerData.child_task_name) || '',
    };
  }

  private created() {
    const extendInfos = {
      productId: this.commodityId,
      ...platform.currentPlatformType,
      pricingType: this.pricingType,
    };
    // 兼容数科app
    let skAdvParams;
    if (platform.isSkApp) {
      skAdvParams = { token: store.state.base.originUserInfo.token };
    }
    // 页面初始化的时候请求广告平台数据
    getAdvData(AdvIdEnum.LOAN_APPLYING, {
      ...skAdvParams,
      extendInfos: {
        [AdvIdEnum.LOAN_APPLYING]: {
          customerParams: {
            ...extendInfos,
          },
        },
      },
    }).then((data: {creative: Dictionary[]}) => {
      // 如果没有数据，则什么都不展示
      if (!data) return;

      if (data && data.creative && data.creative.length) {
        this.show = true;
        const { segment, tracker } = data.creative[0] || [];
        if (segment) {
          this.configData = (segment as Dictionary).data as ApplyProcessingPop;
          const { rightsModelType = '' } = URLUtils.getQueryMap(this.configData.jiweiChannelBDetailPage);
          const { contractScene = '' } = URLUtils.getQueryMap(this.configData.jiweiChannelBDetailPage);
          this.contractScene = contractScene as string;
          this.rightsModelType = Number(rightsModelType);
        }
        if (tracker) {
          this.trackerData = tracker as Dictionary;
        }
        this.$ubtModuleExposeNew('finance_loan_apply_result_popup', this.tqParams);
      }
    });
  }

  private agree() {
    this.contractChecked = !this.contractChecked;
    this.$ubtPageButtonNew('finance_loan_apply_result_popup_agree_click', {
      ...this.tqParams,
      contractChecked: String(this.contractChecked),
    });
  }

  /** 主动支付 */
  private async goBuy() {
    const {
      jiweiChannelBDetailPage,
      jiweiChannelBPayMoney,
    } = this.configData as ApplyProcessingPop || {};

    if (jiweiChannelBDetailPage) {
      const { packageId = '' } = URLUtils.getQueryMap(jiweiChannelBDetailPage);
      const { capitalCode = '' } = URLUtils.getQueryMap(jiweiChannelBDetailPage);
      const { productId = '' } = URLUtils.getQueryMap(jiweiChannelBDetailPage);

      const returnUrl = `${MembersRightsPrefix}${
        MemberRouterNameEnum.ZHENXIANG_CARD_API
      }.html#/${
        MemberRouterNameEnum.ZHENXIANG_CARD_API
      }?from=${RightPackageSourceEnum.LOAN_RESULT_POP}`;
      // if (isEquityRequiredForPricingType(Number(this.pricingType) as PricingTypeEnum)) {
      //   returnUrl = `${MembersRightsPrefix}${
      //     MemberRouterNameEnum.ZHENXIANG_CARD_API
      //   }.html#/${
      //     MemberRouterNameEnum.ZHENXIANG_CARD_API
      //   }?from=${RightPackageSourceEnum.LOAN_RESULT_POP}`;
      // } else {
      //   returnUrl = `${MembersRightsPrefix}${
      //     MemberRouterNameEnum.ZHENXIANG_CARD
      //   }.html#/${
      //     MemberRouterNameEnum.ZHENXIANG_CARD
      //   }?from=${RightPackageSourceEnum.LOAN_RESULT_POP}`;
      // }


      // 主动支付时增加productId回传，保证权益下单逻辑的正确性
      const { payRouteUrl } = await getRightAliPayUrl({
        packageId: packageId as string,
        extendDataJson: {
          capitalCode: capitalCode as string,
          helloFrom: RightPackageSourceEnum.LOAN_RESULT_POP,
        },
        productId: productId as string,
        expectPrice: jiweiChannelBPayMoney || '',
        rightsModelType: this.rightsModelType,
        returnUrl,
      });
      openThirdPage(payRouteUrl);
    }
  }

  private async buy():Promise<unknown> {
    this.$ubtPageButtonNew('finance_loan_apply_result_popup_buy_click', this.tqParams);
    if (!this.contractChecked) {
      this.showContractDialog = true;
      return;
    }
    await this.goBuy();
  }

  private async previewContractDialog() {
    await this.zxCardAppContractInstance?.handleForceRead({
      contractScene: this.contractScene,
      tqParams: this.tqParams,
      preview: true,
      rightsModelType: this.rightsModelType,
    });
  }

  private closeContractDialog() {
    // 不同意埋点
    this.$ubtPageButtonNew('finance_loan_apply_result_popup_disagree_click', this.tqParams);

    this.showContractDialog = false;
  }

  private agreeContractDialog() {
    // 同意协议后埋点
    this.$ubtPageButtonNew('finance_loan_apply_result_popup_protocol_click', this.tqParams);

    this.showContractDialog = false;
    this.contractChecked = true;
    this.goBuy();
  }

  /** 去详情页 */
  private goDetail() {
    if (this.configData && this.configData.jiweiChannelBDetailPage) {
      const { packageId = '', productId = '', capitalCode = '' } = URLUtils.getQueryMap(this.configData.jiweiChannelBDetailPage);
      let jumpUrl = '';
      // if (isEquityRequiredForPricingType(Number(this.pricingType) as PricingTypeEnum)) {
      //   jumpUrl = URLUtils.formatUrl(
      //     `${MembersRightsPrefix}zhenxiang-card.html#/zhenxiang-card`, {
      //       packageId,
      //       productId,
      //       capitalCode,
      //       from: RightPackageSourceEnum.LOAN_RESULT_POP,
      //       rightsModelType: this.rightsModelType,
      //     },
      //   );
      // } else {
      //   jumpUrl = URLUtils.formatUrl(
      //     `${MembersRightsPrefix}zhenxiang-card-hb.html#/zhenxiang-card-hb`, {
      //       packageId,
      //       productId,
      //       capitalCode,
      //       from: RightPackageSourceEnum.LOAN_RESULT_POP,
      //       rightsModelType: this.rightsModelType,
      //     },
      //   );
      // }
      jumpUrl = URLUtils.formatUrl(
        `${MembersRightsPrefix}${
          MemberRouterNameEnum.ZHENXIANG_CARD_API
        }.html#/${
          MemberRouterNameEnum.ZHENXIANG_CARD_API
        }`, {
          packageId,
          productId,
          capitalCode,
          from: RightPackageSourceEnum.LOAN_RESULT_POP,
          rightsModelType: this.rightsModelType,
        },
      );
      openThirdPage(jumpUrl);
      this.$ubtPageButtonNew('finance_loan_apply_result_popup_equity_click', this.tqParams);
    }
  }

  /** 渲染申请中广告弹窗样式 */
  private renderPopContent() {
    // 这里确认要渲染哪个广告模
    return this.renderPop();
  }

  private iconItemEnum = [
    {
      iconImg: 'icon1',
      title: '定制特权',
    },
    {
      iconImg: 'icon2',
      title: '优质用户专享',
    },
    {
      iconImg: 'icon3',
      title: '丰富权益',
    },
  ];

  /** 普通广告位渲染 */
  private renderPop() {
    return (
      <div class={style.applyProcessPopup}>
        <div class={style.bgImg}>
          <div class={style.content} onClick={this.goDetail.bind(this)}>
            <div class={style.detialText}>尽享超值生活权益</div>
            <RightArrowOutline12 class={style.iconImg} color="#bcc4cc"/>
          </div>
        </div>
        <div class={style.contentWrapper}>
          <div class={style.titleGroup}>
            <div class={style.title}>
              您有专属特权可激活
            </div>
          </div>
          <div class={style.iconItemWrapper}>
            {this.iconItemEnum.map((item) => (
              <div class={style.iconItem}>
                <div class={style.iconImg}/>
                <div class={style.iconTitle}>{item.title}</div>
              </div>
            ))}
          </div>
          <Badge
            shape="bubble"
            size="normal"
            outlined
            class={style.buyBadge}
          >
            仅需{this.configData?.jiweiChannelBPayMoney}元
          </Badge>
          <Button
            class={style.buyButton}
            size="large"
            onClick={this.buy.bind(this)}>
            立即激活特权
          </Button>
          <div class={style.contractRadio}>
            <Radio
              modelValue={this.contractChecked}
              onChange={this.agree.bind(this)}
            >
              <div class={style.contractRadioContent}>
                <span class={style.description}>已阅读并同意</span>
              </div>
            </Radio>
            <span
              class={style.contractName}
              onClick={this.previewContractDialog.bind(this)}
            >
              《会员综合协议》
            </span>
          </div>
        </div>
      </div>
    );
  }

  private close() {
    this.show = false;
  }

  /** 渲染 */
  private render() {
    return (
      <div>
        <Popup
          v-model={this.show}
          close-on-click-overlay={false}
          class={style.popup}
          position="center"
        >
          {this.renderPopContent()}
          <div class={style.close} onClick={this.close.bind(this)}></div>
        </Popup>
        <DialogView
          show={this.showContractDialog}
          closeable={false}
          title="请同意协议"
          showCancelButton
          confirmButtonText="同意并开通"
          cancelButtonText="不同意"
          buttonType="horizontal"
          onConfirm={this.agreeContractDialog.bind(this)}
          onCancel={this.closeContractDialog.bind(this)}
          class={style.contractDialog}
        >
          <div class={style.contractContent}>
            亲爱的用户，请先阅读并同意协议及内容
            <div class={style.contractName} onClick={this.previewContractDialog.bind(this)} style={{ color: '#ff5526' }}>
              《会员综合协议》
            </div>
          </div>
        </DialogView>
      </div>
    );
  }
}
